import { APP_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    margin: "60px 0px 20px 0px",
  } as const,
  pageDescription: {
    textAlign: "center",
    fontFamily: FONT_FAMILY,
    fontSize: "28px",
    fontWeight: "bold",
  } as const,
  pageTitlesActive: {
    color: APP_COLOR,
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontSize: "16px",
    fontWeight: "bold",
  } as const,
  pageTitlesDeactive: {
    color: "white",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontSize: "16px",
    fontWeight: "bold",
  } as const,
  sectionButtonsContainer:{
    display: "flex",
    justifyContent: "center",
    gridGap: "10%",
    marginBottom: "30px",
  }as const,
};
